import { render } from "./FolderRenameModal.vue?vue&type=template&id=55456a01"
import script from "./FolderRenameModal.vue?vue&type=script&lang=js"
export * from "./FolderRenameModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__